/** @lint */

/**
 * @module orb/_map
 *
 * Add any lazy-loaded orb modules to the requirejs map.
 */
define('orb/_map', ['orb/lib/_$'], function ($) {
    'use strict';

    return function () {
        var orbScript = $('#orb-js-script')[0], // the script tag that pulls in all of orb.js
            assetPath = $.getAttr(orbScript, 'data-assetpath'),
            map = {};
        //console.log('assetPath is '+ assetPath);
        map['orb/async/_suggestions'] = assetPath + 'js/async/_suggestions.min';

        // update the requirejs paths setting with our new map data
        // TODO use: require.config({})
        require({ paths: map });
    };
});
